import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-17e379f2"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "GroupNewButton" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-plus" }, null, -1));
const _hoisted_3 = [
    _hoisted_2
];
import { ref } from 'vue';
import { useToast } from 'vue-toastification';
import { ModalBox } from '@/components/UI';
import { GroupState, NewGroup } from '@/types/group';
import GroupEdit from './GroupEdit.vue';
import { useGroups } from '@/compositions/useGroups';
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        const toast = useToast();
        const { createGroup } = useGroups();
        const newGroup = ref(new NewGroup('', 0, null, GroupState.Waiting, 5));
        const editVisible = ref(false);
        const startNewGroup = () => {
            editVisible.value = true;
            newGroup.value = new NewGroup('', 0, null, GroupState.Waiting, 5);
        };
        const stopNewGroup = () => {
            editVisible.value = false;
        };
        const addGroup = async () => {
            try {
                await createGroup(newGroup.value);
                toast.success(`Group ${newGroup.value.name} has been created`);
            }
            catch (_a) {
                toast.error(`Could not create group with name ${newGroup.value.name}`);
            }
            editVisible.value = false;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("button", {
                    type: "button",
                    size: "lg",
                    class: "btn btn-warning newbutton btn-circle btn-xl",
                    onClick: _cache[0] || (_cache[0] = ($event) => (startNewGroup()))
                }, _hoisted_3),
                (editVisible.value)
                    ? (_openBlock(), _createBlock(_unref(ModalBox), {
                        key: 0,
                        title: "Create new Group",
                        size: "lg",
                        submitButtonTitle: "Save",
                        onSubmit: _cache[1] || (_cache[1] = ($event) => (addGroup())),
                        onClose: _cache[2] || (_cache[2] = ($event) => (stopNewGroup()))
                    }, {
                        default: _withCtx(() => [
                            _createVNode(GroupEdit, {
                                group: newGroup.value,
                                mode: "create"
                            }, null, 8, ["group"])
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
